function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.75 12.495a2.25 2.25 0 012.25 2.25v1.502l-.008.109c-.31 2.126-2.22 3.148-5.425 3.148-3.193 0-5.134-1.01-5.553-3.112L0 16.246v-1.5a2.25 2.25 0 012.25-2.25h6.5zm-3.25-8a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm12.25-4A2.25 2.25 0 0120 2.745v3.5a2.25 2.25 0 01-2.25 2.25h-1.553l-2.541 2.208A1 1 0 0112 9.948V8.482a2.25 2.25 0 01-2-2.237v-3.5a2.25 2.25 0 012.25-2.25h5.5z",
  fill: "#D5E6F1"
}));